import React, { useState, useEffect } from 'react';
import Video from './Video'
import db from './firebase'
import './App.css';

function App() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    db.collection('videos').onSnapshot(snapshot => setVideos(snapshot.docs.map(doc => doc.data())));
  }, []);

  return (
    <div className="app">
      
      <div className="appVideos">

        {videos.map(
          ({ url, channel, description, song, likes, messages, shares }) => (
            <Video 
              url={url}
              channel={channel}
              description={description}
              song={song}
              likes={likes}
              messages={messages}
              shares={shares}
            />
          )
        )}

        {/* <Video 
        url = "https://v16m.tiktokcdn.com/6270c2fad746b8ba8d12283aff5799c6/5f377a4f/video/tos/useast2a/tos-useast2a-ve-0068c002/9c1a4d851f02405aaf6b3c7b9a803f63/?a=1233&br=1660&bt=830&cr=0&cs=0&dr=0&ds=3&er=&l=202008130601510101890741484605D5D4&lr=tiktok_m&mime_type=video_mp4&qs=0&rc=M3lqMzllOHU7djMzOzczM0ApZjxoNTZpZTs4NzM3Zzg4PGdvXzRqMi5iL25fLS0uMTZzczQuMjYuL141XzU2M2M0NC06Yw%3D%3D&vl=&vr="
        channel = "garyvee"
        description = "This is what most don't understand"
        song = "Original Audio"
        likes = {234}
        messages = {98}
        shares = {56}
        /> */}
      </div>
    </div>
  );
}

export default App;
